import { useShallow } from "zustand/react/shallow";
import { useBoundStore } from "../../state/bound.store";
import { isDebugUser } from "../../utils";
import { Typography } from "@eventr/common-storybook";
import { getUserPref } from "@eventr/common";

export const DebugChatStatus = () => {
  const { rocketWebsocket, rocketSocketStatus } = useBoundStore(
    useShallow((s) => {
      return {
        rocketWebsocket: s.rocketWebsocket,
        rocketSocketStatus: s.rocketSocketStatus,
      };
    }),
  );

  const chatStatusEnabled = getUserPref("account", "enableChatSocketStatus");

  function readyStateColour(readyState: number) {
    switch (readyState) {
      case 0:
        return "blue";
      case 1:
        return "green";
      case 2:
        return "yellow";
      case 3:
        return "red";
      default:
        return "purple";
    }
  }

  function rocketSocketStatusText(status: number | null) {
    switch (status) {
      case 0:
        return "Socket closed";
      case 1:
        return "Socket opening";
      case 2:
        return "Socket open";
      case 3:
        return "Socket connected";
      case 4:
        return "Logged in";
      case -1:
        return "Socket error";
      default:
        return "unknown";
    }
  }

  if ((isDebugUser() || true) && chatStatusEnabled === "dev") {
    return (
      <div
        style={{
          position: "absolute",
          top: "50px",
          left: "16px",
          zIndex: 10000000,
          display: "flex",
          gap: "8px",
        }}
      >
        <div
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "10px",
            backgroundColor: readyStateColour(rocketWebsocket ? rocketWebsocket?.readyState : 4),
          }}
        />
        <Typography
          style={{
            fontSize: "10px",
            color: "white",
            lineHeight: "10px",
            textShadow: "1px 1px 2px black",
          }}
        >
          {rocketSocketStatusText(rocketSocketStatus)}
        </Typography>
      </div>
    );
  } else {
    return <></>;
  }
};
